import React from 'react';
import { pathOr, isNil } from "ramda";


export const getCalculations = (method, data, filterarr = [],allTabFilter=[]) => {

	const decimalUpto2 = new Intl.NumberFormat('en-US', {maximumFractionDigits: 2, minimumFractionDigits: 2})
	const decimalUpto4 = new Intl.NumberFormat('en-US', {maximumFractionDigits: 4, minimumFractionDigits: 2})
	//console.log("PolicyCalculation",filterarr,allTabFilter)
	let current_currency = pathOr(pathOr('USD', ["currency",'value'], filterarr), [0, "currency"], allTabFilter);
	switch (method) {
		case 'getValueWithCurrency':
		case 'getValueInDecimal':
	// console.log("allTabFilter",filterarr)
			return <>{current_currency} {new Intl.NumberFormat('en-US', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(data)}</>
			// let getCurrency = currencies.find((currency) => {
			// 	return currency.iso4217 === current_currency;
			// })
			// console.log("filterarrrrrrrrrrrrrr",allTabFilter);
			// let conversion_rate = 1;//getCurrency?getCurrency['conversion_rate']:1;
			//   let converted= <NumberFormat value={(data.replace(/,/g, '')*conversion_rate).toString()} displayType={'text'} thousandSeparator={true} decimalScale={2}  />;
			
			// <NumberFormat value={(data.replace(/,/g, '') * conversion_rate).toString()} displayType={'text'} thousandSeparator={true} decimalScale={2} /></>;
		// return filterarr['currency']['value']+" "+(data.replace(/,/g, '')*conversion_rate);
		case 'getValueInDecimalAndPercent':
		case 'convertIntoPercent':	
			return (data !== 'NA') ? decimalUpto2.format(data* 100)+"%" : 'NA';
		case 'convertIntoPercentWithoutSign':	
			return (data !== 'NA') ? decimalUpto2.format(data* 100) : 'NA';
		case 'getValueOnlyInDecimal':
		return data ? decimalUpto2.format(data):data === 0? data:null;
		case 'getValueOnlyInDecimalAndPercent':
		return (data !== 'NA') ? data ? decimalUpto2.format(data)+"%":data === 0? data+"%":null : 'NA';
		// 03/02/2023: Added Frontend code as per AXA request to show upto 4 digits after decimal place for unit price
		case 'getUnitPriceInDecimal':
		return data === '--' ? data : data ? decimalUpto4.format(data) : data === 0 ? data : null;
		// Added code as per AXA requirement to show upto 4 digit places in unit price in report 29/03/2023
		case 'getUnitPriceInDecimalCurrency':
		return data === '--' ? data : `${current_currency === 'USD'? '$' : '₱'} ${data ? decimalUpto4.format(data) : data === 0 ? data : null}`;
		// case 'getValueInDecimal':
		// 	return <>{ pathOr('USD', [0, "currency"], allTabFilter)} <NumberFormat value={(data.replace(/,/g, '')).toString()} displayType={'text'} thousandSeparator={true} decimalScale={2} /></>;
		// return filterarr['currency']['value']+" "+(data.replace(/,/g, '')*conversion_rate);
		// case 'convertIntoPercent':
		// 	return <>{data !== 'NA' ? <><NumberFormat value={(data * 100).toString()} displayType={'text'} thousandSeparator={true} decimalScale={2} /></> : 'NA'}</>;
		case 'getValueWithCurrencySymbol':
			return data==='--'? data : `${current_currency === 'USD'? '$' : '₱'}${data?new Intl.NumberFormat('en-US', {maximumFractionDigits: 2}).format(data):0}`;
			break;
		case 'getChartData':
			
			const chartRows=Object.keys(pathOr({}, [0] ,data));
			const chartRows1=[];	//[chartRows]

			data.map((row) => {
				chartRows1.push(Object.values(row));
			})
			// console.log(chartRows1);
			return chartRows1;
		case 'getLineChartData':
			if(data.length == 0){
				return data;
			}
			const chartRowsLine=Object.keys(pathOr({}, [0] ,data))
			const chartRowsLine1=['x'];	//[chartRows]
			const chartRowsLine2=[pathOr({}, [1] ,chartRowsLine)];	//[chartRows]

			data.map((row) => {
			chartRowsLine1.push(row[chartRowsLine[0]]);
			chartRowsLine2.push(row[chartRowsLine[1]]);
			})
			// console.log([chartRowsLine1,chartRowsLine2])
			return [chartRowsLine1,chartRowsLine2];
		case 'getCurrentChart':
			if(data.length == 0){
				return data;
			}
			let chartData = [];
			let chartFinalData = [];
			let fundTypeList = ['Equities','Bonds','Balanced'];

			let calPer = (100 / data.length);

			data.map((row) => {
				const rowFundType=pathOr('', ['FundType'], row);
				let newFundType = rowFundType==='Equity'?'Equities':rowFundType==='Bond'?'Bonds':rowFundType;
				chartData[newFundType] = (chartData[newFundType] || 0) + 1;
			})
			fundTypeList.map((row, rowNum) => {
				chartFinalData[rowNum] = [row, (calPer * chartData[row])];
			})
			return chartFinalData;
		case 'getCurrentChart2':
			if(data.length == 0){
				return data;
			}
			let chartData2 = [];
			let chartFinalData2 = [];
			let fundTypeList2 = ['Equities','Bonds','Balanced'];

			let calPer2 = (100 / data.length);

			data.map((row) => {
				const rowFundType=pathOr('', ['data', 'FundType'], row);
				let newFundType = rowFundType==='Equity'?'Equities':rowFundType==='Bond'?'Bonds':rowFundType;
				chartData2[newFundType] = (chartData2[newFundType] || 0) + 1;
			})
			fundTypeList2.map((row, rowNum) => {
				chartFinalData2[rowNum] = [row, (calPer2 * chartData2[row])];
			})
			return chartFinalData2;
		case 'getStrategicChart':
			let chartDataStrategic = [];
			data.map((row) => {
				chartDataStrategic.push([pathOr(pathOr('', ['data', 'name'], row), [ 'name'], row), pathOr(pathOr('', ['data', 'percentage'], row), ['percentage'], row)]);

			})

			return chartDataStrategic;
		case 'getGeoChart':
			const geoData=[['Region Code', 'Continent', 'Account Value']];
			
			data.map((row) => {
			let accountValue = Math.floor(row.AV.replace(",", ""));
			
				switch(row['FundTypeName']){
					
					case "Asian Equity":
						geoData.push(['142', 'Asian Equity', accountValue]);
						break;
					case "Domestic Bond":
						geoData.push(['035', 'Domestic Bond', accountValue]);
					case "Domestic Balanced":
						geoData.push(['035', 'Domestic Balanced', accountValue]);
					case "Domestic Equity":
						geoData.push(['035', 'Domestic Equity', accountValue]);
					case "Domestic Money Market":
						geoData.push(['035', 'Domestic Money Market', accountValue]);
						break;
					case "Global Bond":
						geoData.push(['154', 'Global Bond', accountValue]);
						geoData.push(['155', 'Global Bond', accountValue]);
						geoData.push(['151', 'Global Bond', accountValue]);
						geoData.push(['039', 'Global Bond', accountValue]);
				
					case "Global Balanced":
						geoData.push(['154', 'Global Balanced', accountValue]);
						geoData.push(['155', 'Global Balanced', accountValue]);
						geoData.push(['151', 'Global Balanced', accountValue]);
						geoData.push(['039', 'Global Balanced', accountValue]);
				
					case "Global Equity":
						geoData.push(['154', 'Global Equity, Global Bond, Global Balanced', accountValue]);
						geoData.push(['155', 'Global Equity', accountValue]);
						geoData.push(['151', 'Global Equity', accountValue]);
						geoData.push(['039', 'Global Equity', accountValue]);
						geoData.push(['002', 'Global Equity', accountValue]);

						
						break;
					case "European Equity":
						geoData.push(['154', 'European Equity', accountValue]);
						geoData.push(['155', 'European Equity', accountValue]);
						geoData.push(['151', 'European Equity', accountValue]);
						geoData.push(['039', 'European Equity', accountValue]);
						break;
					case "US Equity":
						geoData.push(['021', 'US Equity', accountValue]);
						geoData.push(['029', 'US Equity', accountValue]);
						geoData.push(['013', 'US Equity', accountValue]);
						geoData.push(['005', 'US Equity', accountValue]);
						break;
							default:
								return method;
						
				}
			})
			return geoData;
		case 'getYourTransaction':
			let tableCustomizeData = [];
			const summaryOfTransactions = pathOr([], ['summaryOfTransactions'], data);
			const columnToCalculate = Object.entries(pathOr([], ['columnToCalculate'], data));
			const tableData = pathOr([], ['tableData'], data);
			const lenghtOfData = pathOr(tableData, ['data'], tableData).length;
			// console.log('columnToCalculate', columnToCalculate);
			// console.log('lenghtOfData', lenghtOfData);
			// console.log('summaryOfTransactions', summaryOfTransactions);
			summaryOfTransactions.map((rowInfo, rowKey) =>{
				// console.log("rowInfo", rowInfo);
				let fundTrancsactionName = rowInfo.name;
				let formulas = pathOr({}, ['formula'], rowInfo);
				const ExtractOperation = Object.entries(formulas);
				const getColumnsData = {};
				columnToCalculate.map(([queryColumnKey, tableColumnkey]) => {
					getColumnsData[tableColumnkey] = 0;
				});
				ExtractOperation.forEach(([operation, eachOperationValue]) => {
					eachOperationValue.map((eachValue) => {
						for(let i=0; i<lenghtOfData; i++){
							if(eachValue === pathOr(pathOr(pathOr(0, [i, 'trcode'], tableData), [i, 'transactioncode'], tableData), ['data', i, 'transactioncode'], tableData)){
								columnToCalculate.map(([queryColumnKey, tableColumnkey]) => {
									let value = Number(pathOr(pathOr(0, [i, queryColumnKey], tableData), ['data', i, queryColumnKey], tableData));
									switch (operation) {
										case 'SUM':
											getColumnsData[tableColumnkey] += value;
											break;
										case 'MINUS':
											getColumnsData[tableColumnkey] -= value;
											break;
										default:
											break;
									}
								});
								// console.log(fundTrancsactionName, getColumnsData);
								// let fundValue = Number(pathOr(0, [i, 'amount'], tableData.data));
								// let monthFundValue = Number(pathOr(0, [i, 'monthAmount'], tableData.data));
								// switch (operation) {
								// 	case 'SUM':
								// 		total += fundValue;
								// 		monthTotal += monthFundValue;
								// 		break;
								// 	case 'MINUS':
								// 		total -= fundValue;
								// 		monthTotal -= monthFundValue;
								// 		break;
								// 	default:
								// 		break;
								// }
							}
						}
					});
				});
				
				tableCustomizeData[rowKey] = {fundTrancsactionName, ...getColumnsData}; 
			});
			// console.log("TableData", TableData);
			return tableCustomizeData;
			break; 
		
		case 'getPolicyAllocationTable':
			const currentAllocData = Object.fromEntries(getCalculations('getCurrentChart', data[0]));
			const strategicAllocData = Object.fromEntries(getCalculations('getStrategicChart', data[1]));
			let customizeTableData = [];
			Object.keys(currentAllocData).map((fundType, key) => {
				let makeRowData = {};
				makeRowData['fundType'] = fundType;
				let result = Number(currentAllocData[fundType]) - Number(strategicAllocData[fundType]);
				if(result > 0){
					makeRowData['overweight'] = getCalculations('getValueOnlyInDecimalAndPercent', result);
					makeRowData['underweight'] = null;
				}else if(result < 0){
					makeRowData['underweight'] = getCalculations('getValueOnlyInDecimalAndPercent', (result * -1));
					makeRowData['overweight'] = null;
				}else{
					makeRowData['underweight'] = null;
					makeRowData['overweight'] = null;
				}	
				customizeTableData[key] = makeRowData;		
			});

			return customizeTableData;
			break;

		case 'getSpRp-ITChartData':
			// console.log("data", data);
			var maxBar = 0;	
			const queryStructure = 	pathOr([], ['data', 'charts',0,'data','query'], data);
			const fullDataResult = 	pathOr([], ['result'], data);
			const chartTitle = 	pathOr([], ['data', 'charts',0,'title'], data);
			const chartType = 	pathOr([], ['data', 'charts',0,'data','chartType'], data);
			const groupChart = 	pathOr([], ['data', 'charts',0,'data','groupChart'], data);
			const columnToCalculateSPRP = [];
			let getChartData = [];
			let yearArray = [];
			queryStructure.forEach((eachQueryStru) => {
				let [temp] = Object.entries(eachQueryStru['columnToCalculate']);
				columnToCalculateSPRP[temp[0]] = temp[1];
				getChartData[temp[0]] = [temp[0]];
			});
			let minYear = '';
			let maxYear = '';
			Object.values(fullDataResult).forEach((eachDataResult) => {
				eachDataResult.forEach((dataItem) =>{
					if(minYear == '' || minYear > dataItem['Year'] ){
						minYear = parseInt(dataItem['Year']);
					}else if(maxYear == '' || maxYear < dataItem['Year'] ){
						maxYear = parseInt(dataItem['Year']);
					}
				});
			});
			yearArray.push('x');
			for(let year=minYear; year<=maxYear; year++) {
				yearArray.push(year);
				Object.entries(fullDataResult).forEach(([dataName, dataValue]) => {
					let isFound = false;
					dataValue.map((dataRow) => {
						if(year == dataRow.Year){
							getChartData[dataName].push(dataRow[columnToCalculateSPRP[dataName]]);
							isFound = true;
						}
					});
					if(!isFound){
						let lengthofLastValue = getChartData[dataName].length -1;
						getChartData[dataName].push(lengthofLastValue == 0 ? 0 :getChartData[dataName][lengthofLastValue]);
					}
				});
			}
			maxBar = yearArray.length
			let finalChartData = [];
			if(minYear != '' && maxYear != ''){
				finalChartData.push(yearArray);
				Object.values(getChartData).forEach((row) => {
					finalChartData.push(row);
				});
			}
			return {finalChartData,maxBar,chartType,groupChart,chartTitle};
			break;

		case 'getSpOrRp-ITChartData':
			// console.log("data",data)
			let maxBarSpOrRp = 0;
			const queryStructureSpOrRp = pathOr([], ['RowParameter','query',0,'lists'], data);
			// pathOr([], ['RowParameter','query',0,'lists'], data).forEach((eachQuery, eachQueryKey) => {
			// 	queryStructureSpOrRp[eachQueryKey] = eachQuery;
			// });
			const fullDataResultSpOrRp = 	pathOr([], ['chartData',0], data);
			const chartTitleSpOrRp = 	pathOr([], ['RowParameter', 'name'], data);
			const chartTypeSpOrRp = 	pathOr([], ['RowParameter','chartType'], data);
			const groupChartSpOrRp = 	pathOr([], ['RowParameter','groupChart'], data);
			const columnToCalculateSPRPSpOrRp = [];
			let getChartDataSpOrRp = [];
			let yearArraySpOrRp = [];
			queryStructureSpOrRp.forEach((eachQueryStru) => {
				let [temp] = Object.entries(eachQueryStru['columnToCalculate']);
				columnToCalculateSPRPSpOrRp[temp[0]] = temp[1];
				getChartDataSpOrRp[temp[0]] = [temp[0]];
			});
			// console.log("getChartDataSpOrRp", getChartDataSpOrRp);
			let minYearSpOrRp = '';
			let maxYearSpOrRp = '';
			Object.entries(fullDataResultSpOrRp).forEach(([eachDataKey,eachDataResult]) => {
				eachDataResult.forEach((dataItem) =>{
					if(minYearSpOrRp == '' || minYearSpOrRp > dataItem['Year'] && !isNil(dataItem[columnToCalculateSPRPSpOrRp[eachDataKey]]) ){
						minYearSpOrRp = parseInt(dataItem['Year']);
					}else if(maxYearSpOrRp == '' || maxYearSpOrRp < dataItem['Year'] && !isNil(dataItem[columnToCalculateSPRPSpOrRp[eachDataKey]]) ){
						maxYearSpOrRp = parseInt(dataItem['Year']);
					}
				});
			});
			yearArraySpOrRp.push('x');
			for(let year=minYearSpOrRp; year<=maxYearSpOrRp; year++) {
				yearArraySpOrRp.push(year);
				Object.entries(fullDataResultSpOrRp).forEach(([dataName, dataValue]) => {
					let isFound = false;
					dataValue.map((dataRow) => {
						if(year == dataRow.Year){
							getChartDataSpOrRp[dataName].push(dataRow[columnToCalculateSPRPSpOrRp[dataName]]);
							isFound = true;
						}
					});
					if(!isFound){
						let lengthofLastValue = getChartDataSpOrRp[dataName].length -1;
						getChartDataSpOrRp[dataName].push(lengthofLastValue == 0 ? 0 :getChartDataSpOrRp[dataName][lengthofLastValue]);
					}
				});
			}
			maxBarSpOrRp = yearArraySpOrRp.length
			let finalChartDataSpOrRp = [];
			if(minYearSpOrRp != '' && maxYearSpOrRp != ''){
				finalChartDataSpOrRp.push(yearArraySpOrRp);
				Object.values(getChartDataSpOrRp).forEach((row) => {
					finalChartDataSpOrRp.push(row);
				});
			}
			// console.log("finalChartDataSpOrRp", finalChartDataSpOrRp);
			return {...data.RowParameter, finalChartData:finalChartDataSpOrRp,maxBar:maxBarSpOrRp,chartType:chartTypeSpOrRp,groupChart:groupChartSpOrRp,chartTitle:chartTitleSpOrRp};
			break;

		case 'portfolioLast5Year':
			var maxBar_5Year = 5;	
			const chartData_5Year = 	pathOr([], ['chartData', 0], data);
			const chartTitle_5Year = 	pathOr([], ['RowParameter', 'title'], data);
			const chartType_5Year = 	pathOr([], ['RowParameter', 'chartType'], data);
			const typeOfChart_5Year = 	pathOr([], ['RowParameter', 'typeOfChart'], data);
			const groupChart_5Year = 	pathOr([], ['RowParameter', 'groupChart'], data);

			let getChartData_5Year = [];
			let yearLabel = ['x'];
			const currYear = new Date().getFullYear();
			for (let index = 4; index >= 0; index--) {
				yearLabel.push(currYear-index);
			}
			getChartData_5Year.push(yearLabel);
			Object.entries(chartData_5Year).map(([key, value]) => {
				let getLast5YearCagr = Object.values(pathOr([], ['overall','cagr'], value)).map(x => x * 100);
				let getLast5YearYearly = Object.values(pathOr([], ['overall','yearly'], value)).map(x => x * 100);
				let cagrLength = getLast5YearCagr.length;
				let YearlyLength = getLast5YearCagr.length;
				for(let i=0;i<(5-cagrLength);i++){
					getLast5YearCagr.unshift(0);
				}
				for(let i=0;i<(5-YearlyLength);i++){
					getLast5YearYearly.unshift(0);
				}
				let tempCagrData =  getLast5YearCagr.slice(getLast5YearCagr.length-5, getLast5YearCagr.length);
                let tempYearlyData =  getLast5YearYearly.slice(getLast5YearYearly.length-5, getLast5YearYearly.length);
				if(key === 'SP'){
					tempCagrData.unshift('Yearly ave. returns of SP portfolio');
					tempYearlyData.unshift('SP Portfolio Yearly Returns');
				}else if(key === 'RP'){
					tempCagrData.unshift('Yearly ave. returns of RP portfolio');
					tempYearlyData.unshift('RP Portfolio Yearly Returns');
				}
                getChartData_5Year.push(tempCagrData);
                getChartData_5Year.push(tempYearlyData);
			});
			return {finalChartData: getChartData_5Year,...data.RowParameter, maxBar_5Year};
			// return {finalChartData: fullDataResult_5Year,maxBar:maxBar_5Year,typeOfChart: typeOfChart_5Year,chartType: chartType_5Year,groupChart:groupChart_5Year,chartTitle: chartTitle_5Year};
			// return <CustomDashletMixChart key={'123'} data={{name:chartTitle_5Year,type:chartType_5Year}} fullData={{finalChartData: fullDataResult_5Year,maxBar:maxBar_5Year,chartType: chartType_5Year,groupChart:groupChart_5Year,chartTitle: chartTitle_5Year}}/>;
			break;
		case 'policyLast5Year':
				const data5Year = 	pathOr([], ['chartData', 0], data);
				const effectiveData = pathOr([], ['chartData', 1], data)
				const effectiveDate = pathOr('', ["data", "effectivedate"], effectiveData)
				const effectiveYear = new Date(effectiveDate).getFullYear()
				const cagrData = pathOr({}, ['0', 'cagr'], Object.values(data5Year))
				const yearlyData = pathOr({}, ['0', 'yearly'], Object.values(data5Year))
				const lengthOfYearData = Math.min(Object.values(cagrData).length, Object.values(yearlyData).length);
				var maxBar_5Year = 5;
				let getData5Year = [];
				const currentYear = effectiveYear + lengthOfYearData;
				const xLabel = ['x', ...Array.from({ length: maxBar_5Year }, (_, i) => currentYear - i).toReversed()];
				getData5Year.push(xLabel);
				Object.entries(data5Year).map(([key, value]) => {
					let getLast5YearCagr = Object.values(pathOr([], ['cagr'], value)).map(x => typeof(x) == "number" && !isNaN(x) ? x * 100 : 0);
					let getLast5YearYearly = Object.values(pathOr([], ['yearly'], value)).map(x => typeof(x) == "number" && !isNaN(x) ? x * 100 : 0);
					let cagrLength = getLast5YearCagr.length;
					let YearlyLength = getLast5YearCagr.length;
					for(let i=0;i<(maxBar_5Year-cagrLength);i++){
						getLast5YearCagr.unshift(0);
					}
					for(let i=0;i<(maxBar_5Year-YearlyLength);i++){
						getLast5YearYearly.unshift(0);
					}
					let tempCagrData =  getLast5YearCagr.slice(getLast5YearCagr.length-maxBar_5Year, getLast5YearCagr.length);
					let tempYearlyData =  getLast5YearYearly.slice(getLast5YearYearly.length-maxBar_5Year, getLast5YearYearly.length);
					tempCagrData.unshift('Average Annual Returns')
					tempYearlyData.unshift('Year on Year Returns')
					getData5Year.push(tempCagrData);
					getData5Year.push(tempYearlyData);	
				});
				return {finalChartData: getData5Year,...data.RowParameter, maxBar_5Year};
				break;
			
		case 'portfolioStacked':
			let chartDataStacked = [];
			let stackedData=pathOr([], [0,'data'], data);
			let stackedGrouped=[];
			Object.keys(stackedData).map((row) => {
				chartDataStacked.push([row,stackedData[row]]);
				stackedGrouped.push(row);
			})
				return {'data':chartDataStacked,'group':stackedGrouped};

		default:
			return method, data;
	}
};

